import type { CheckoutCopy } from '../model/checkout_copy.js';
import type { CheckoutProductType } from '../model/checkout_source.js';

/** O contexto do carrinho para o chrome da tela cheia (o chip do topo) e o
 *  cartão "Sua viagem". O produto deriva o que o fio dele carrega
 *  (`products/checkout_screen.tsx`); os demais campos ficam ausentes. */
export interface CheckoutContext {
  /** The product chip of the header ("Voo"). */
  chip: string;
  /** The product noun of the CTA ("voo"). */
  noun: string;
  /** "Rio de Janeiro → São Paulo". */
  route?: string;
  /** A janela curta do roteiro ("17 – 22 set"). */
  dates?: string;
  /** Cidade destino pro título da viagem. */
  city?: string;
  /** Noites inteiras da estadia/viagem, > 0. */
  nights?: number;
}

/** Só os rótulos do produto. */
export function productContextLabels(
  copy: CheckoutCopy,
  productType: CheckoutProductType,
): Pick<CheckoutContext, 'chip' | 'noun'> {
  return copy.products[productType];
}
